import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PageLoadingIndicator } from '@kioskgaming/page-loading';
import { useCashierAuth } from '../../hooks/useCashierAuth';

export default function CashierProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useCashierAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <PageLoadingIndicator variant="section" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

